import { createApp } from 'vue'
import App from '@/apps/App.vue'
import router from '@/apps/router'
import IconTemplate from '@/apps/components/IconTemplate.vue'
import ElementPlus from 'element-plus'
import Maska from 'maska'
import 'element-plus/dist/index.css'
import '@/apps/styles/index.scss'
import '@/apps/permissions'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
app.use(ElementPlus)
app.use(Maska)
app.use(router)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

const requireAll = (requireContext) => requireContext.keys().map(requireContext)
requireAll(require.context('@/apps/assets/icons/', true, /\.svg$/))
app.component('IconTemplate', IconTemplate)

export { app }
